import { componentWithCondition } from '@atlassian/jira-feature-flagging-utils';
import { fg } from '@atlassian/jira-feature-gating';
import ViewOld from './view-old.tsx';
import View from './view.tsx';

export default componentWithCondition(() => !fg('plan-timeline-non-transposed'), View, ViewOld);
